module.exports = __webpack_public_path__ + "media/images/emblems/Muehlau-blason-fb905dd26bbd56202c212930d2307dd3.png";